<template>
    <div id="translateForm">

        <div class="translation-container">
            <div class="original-text">
                <select v-model="sourceLanguage"
                        class="custom-select"
                        @change="fetchTranslation">
                    <option value="">Automatically detect </option>
                    <option v-for="(lang, code) in supportedLanguages"
                            :value="code"
                            :key="code">{{ lang.name }}</option>
                </select>
                <textarea v-model="textToTranslate"
                          placeholder="Please enter the content..."
                          class="custom-textarea original-area"
                          @input="limitTextLength"></textarea>
                <div>{{ characterCount }} / 500 </div>
            </div>

            <!-- <button @click="swapLanguages"
                    class="swap-button"
                    title="切换语言">&#8646;</button> -->
            <img src="../img/switch01.png"
                 style=" cursor: pointer;"
                 @click="swapLanguages"
                 title="切换语言"
                 alt="切换语言">
            <div class="translated-text">
                <select v-model="targetLanguage"
                        class="custom-select"
                        @change="fetchTranslation">
                    <option v-for="(lang, code) in supportedLanguages"
                            :value="code"
                            :key="code">{{ lang.name }}</option>
                </select>
                <!-- 使用 v-if 来控制是否显示加载效果 -->
                <textarea :value="translatedText"
                          placeholder=''
                          readonly
                          class="custom-textarea translated-area">
                          </textarea>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'TranslateForm',
    data() {
        return {
            isLoading: true,
            textToTranslate: '',
            sourceLanguage: 'en',
            targetLanguage: 'es',
            maxCharacterCount: 500, // 最大字符数
            supportedLanguages: {}, // 存储从 API 获取到的语言列表
            translatedText: '', // 存储翻译后的文本
        }
    },
    watch: {
        textToTranslate(newVal) {
            // 当 textToTranslate 发生变化时执行翻译
            if (newVal.trim() !== '') {
                this.fetchTranslation()
            } else {
                this.translatedText = '' // 清空翻译结果
            }
        },
    },
    mounted() {
        this.fetchSupportedLanguages()
    },
    methods: {
        clearText() {
            // 清空文本域内容
            this.textToTranslate = ''
            this.characterCount = 0
        },
        limitTextLength(event) {
            const text = event.target.value
            this.characterCount = text.length

            if (text.length > this.maxCharacterCount) {
                // 如果超出最大长度，截断输入内容为最大长度
                this.textToTranslate = text.substring(0, this.maxCharacterCount)
                this.characterCount = this.maxCharacterCount
            }
        },
        async fetchSupportedLanguages() {
            const subscriptionKey = 'f1f0abb1e6bf474fa0d7b9e7b193b66d'
            const endpoint =
                'https://api.cognitive.microsofttranslator.com/languages?api-version=3.0'
            console.log(this.$http)
            try {
                const response = await this.$http.get(endpoint, {
                    headers: {
                        'Accept-Language': 'en',
                        'Ocp-Apim-Subscription-Key': subscriptionKey,
                    },
                })

                this.supportedLanguages = response.data.translation
            } catch (error) {
                console.error('Error fetching supported languages:', error)
            }
        },
        async fetchTranslation(value) {
            const subscriptionKey = 'f1f0abb1e6bf474fa0d7b9e7b193b66d'
            const endpoint =
                'https://api.cognitive.microsofttranslator.com/translate?api-version=3.0'

            if (
                !this.textToTranslate ||
                this.textToTranslate.trim() === '' ||
                value == 'stop'
            ) {
                console.log('看看是啥', value == 'stop')
                // 如果文本为空或仅包含空格，则不执行翻译
                if (value !== 'stop') {
                    this.translatedText = ''
                }
                return
            }
            this.isLoading = true
            this.translatedText = 'Translation...'

            try {
                const response = await this.$http.post(
                    endpoint,
                    [{ text: this.textToTranslate }],
                    {
                        headers: {
                            'Ocp-Apim-Subscription-Key': subscriptionKey,
                            'Content-Type': 'application/json',
                        },
                        params: {
                            from: this.sourceLanguage,
                            to: this.targetLanguage,
                        },
                    }
                )
                if (response.status === 200) {
                    this.translatedText = response.data[0].translations[0].text
                }
            } catch (error) {
                console.error('Error fetching translation:', error)
            } finally {
                this.isLoading = false
            }
        },
        swapLanguages() {
            // 交换源语言和目标语言
            const temp = this.sourceLanguage == '' ? 'es' : this.sourceLanguage
            this.sourceLanguage = this.targetLanguage
            this.targetLanguage = temp

            // 交换翻译文本
            const tempText = this.textToTranslate
            this.textToTranslate = this.translatedText
            this.translatedText = tempText
            // 通知不用重新获取翻译
            this.fetchTranslation('stop')
        },
    },
}
</script>

<style scoped>
/* 样式 */
.language-selector {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 10px;
}

.translation-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
/* 选择框的样式 */
.custom-select {
    margin: 0 0 20px 15px;
    appearance: none;
    width: 200px;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 50px; /* 将边框半径设为半径的一半，使其看起来像椭圆形 */
    outline: none;
    cursor: pointer;
    transition: border-color 0.3s ease;
    /* 添加背景和箭头 */
    background-image: url('data:image/svg+xml;utf8,<svg fill="black" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
    background-position: right 10px center; /* 调整箭头位置 */
    background-repeat: no-repeat;
    background-size: 20px; /* 调整箭头大小 */
}

/* 悬停时的样式 */
.custom-select:hover {
    border-color: #999; /* 悬停时改变边框颜色 */
}

/* 点击时的样式 */
.custom-select:focus {
    border-color: #333; /* 点击时改变边框颜色 */
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3); /* 添加点击时的阴影效果 */
}

/* 交换按钮的样式 */
.swap-button {
    /* 添加您想要的样式，例如背景颜色、悬停效果等 */
}
.original-text {
    margin-top: 30px;
}
.original-text,
.translated-text {
    display: flex;
    flex-direction: column;
    padding: 10px;
}
.custom-textarea {
    border: 1px solid #ccc;
    border-radius: 20px; /* 设置边框半径为高度的一半，使其呈现椭圆形 */
    padding: 8px 15px;
    margin-bottom: 10px;
    font-size: 16px; /* 控制输入框中文字的大小 */
    font-family: 'Microsoft YaHei', Arial, Helvetica, Sans-Serif; /* 控制输入框中文字的字体 */
    outline: none;
    position: relative;
    transition: border-color 0.3s ease;
    width: 550px; /* 输入框宽度充满父容器 */

    height: 1200px;
    box-sizing: border-box; /* 包含边框在内的宽度 */
    max-width: 500px; /* 最大宽度为300px */
    max-height: 600px; /* 最大高度为800px */
    overflow: auto; /* 超出宽度和高度时显示滚动条 */
}

/* 悬停时样式 */
.custom-textarea:hover {
    border-color: #999;
}

/* 点击时样式 */
.custom-textarea:focus {
    border-color: #333;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

/* 交换按钮样式 */
.swap-button {
    border: 1px solid #ccc;
    border-radius: 20px; /* 设置边框半径为高度的一半，使其呈现椭圆形 */
    padding: 8px 15px;
    height: 80px;
    margin-bottom: 10px;
    outline: none;
    cursor: pointer;
    transition: background-color 0.3s ease; /* 添加背景颜色的过渡效果 */
}
.custom-textarea {
    resize: none;
}
/* 悬停时样式 */
.swap-button:hover {
    background-color: #f0f0f0; /* 悬停时改变背景颜色 */
}

/* 点击时样式 */
.swap-button:active {
    background-color: #e0e0e0; /* 点击时改变背景颜色 */
}
/* 加载动画样式 */
.loading-animation {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px; /* 设置适当的高度 */
}
.original-area {
    max-width: 550px;
    font-size: 22px;
    color: #2f255b;
}
.translated-area {
    max-width: 550px;
    font-size: 22px;
    color: #2f255b;
    background-color: #ebecf4;
}
.dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 5px;
    background-color: #000;
    opacity: 0;
    animation: dotAnimation 1.5s infinite; /* 设置动画效果 */
}

.dot1 {
    animation-delay: 0s;
}
.dot2 {
    animation-delay: 0.5s;
}
.dot3 {
    animation-delay: 1s;
}

@keyframes dotAnimation {
    0%,
    20%,
    80%,
    100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1);
    }
}
@media screen and (max-width: 640px) {
    .translation-container {
        flex-direction: column;
    }
    .swap-button {
        height: 30px;
        width: 200px;
    }
    .original-area {
        height: 340px;
        max-width: 260px;
        font-size: 22px;
        color: #2f255b;
    }
    .translated-area {
        max-width: 260px;
        height: 340px;
        font-size: 22px;
        color: #2f255b;
        background-color: #ebecf4;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/TranslateForm.vue